export enum MetaConnectionPosition {
  left = 'left',
  right = 'right',
}
